<template>
  <div class="password-lock-overlay" v-if="isVisible">
    <div class="password-lock-backdrop"></div>
    <div class="password-lock-container">
      <h2>攀达海淘</h2>
      <div class="textjieshao">多端合一查询系统</div>
      <input 
        type="text" 
        v-model="password" 
        :maxlength="maxChars" 
        @keyup.enter="submitPassword" 
        placeholder="请输入口令" 
      />
      <button @click="submitPassword">登录</button>
      <p v-if="errorMessage">{{ errorMessage }}</p>
      <br><br>
      <img src="@/assets/gongan.png" alt="图标" class="icon"/>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010602002923" target="_blank">川公网安备51010602002923号</a><br>
      <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025149997号</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { inject, ref } from 'vue';

export default {
  setup() {
    const isVisible = ref(true);
    const password = ref('');
    const errorMessage = ref('');
    const globalState = inject('globalState');
    const globalConfig = inject('globalConfig');
    const maxChars = 100; // 最大字符数

    const submitPassword = async () => {
      if (password.value.length > maxChars) {
        errorMessage.value = `密码长度不能超过 ${maxChars} 个字符`;
        return;
      }

      try {
        const response = await axios.post(`${globalConfig.apiUrl}/HsInquire/password`, {
          password: password.value
        });
        if (response.data.success) {
          localStorage.setItem('authenticated', 'true');
          localStorage.setItem('password', password.value); // 保存密码
          globalState.authenticated = true; // 更新全局状态
          isVisible.value = false;
        } else {
          errorMessage.value = '非正确密钥';
        }
      } catch (error) {
        console.error('请求提交密码时出错:', error);
        errorMessage.value = '系统错误';
      }
    };

    return {
      isVisible,
      password,
      errorMessage,
      submitPassword,
      maxChars
    };
  }
};
</script>


<style scoped>
.textjieshao {
  text-align: center;
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 500;
}

.password-lock-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.4);
}

.password-lock-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6); /* 雾玻璃效果的背景色 */
  backdrop-filter: blur(20px); /* 应用模糊效果 */
}

/*边框氛围 */
.password-lock-container {  
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  z-index: 1;
  width: 90%;
  max-width: 400px;
}

input[type="text"] {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 16px;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  border: none;
  border-radius: 10px;
  background-color: #007aff;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background-color: #005ecb;
}

p {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}
.icon {
  width: 16px;
  height: 16px;
}
</style>
